<template>
    <div>
        <section class="app-content">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <button class="btn btn-primary" type="button" v-on:click="sendMessageCalculator()">
                <i class="fa fa-fw fa-lg fa-save"></i>
                <span class=text>Send Message Calculator</span>
            </button>

            <!-- &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <button class="btn btn-primary" type="button" v-on:click="sendMessageBank()">
                <i class="fa fa-fw fa-lg fa-save"></i>
                <span class=text>Send Message Bank</span>
            </button> -->

            <!-- &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <button class="btn btn-primary" type="button" v-on:click="reciveMessageSOAP()">
                <i class="fa fa-fw fa-lg fa-save"></i>
                <span class=text>Recive Message</span>
            </button> -->
        </section>
    </div>
</template>

<script>
    export default {
        methods: {
            sendMessageCalculator(){
                var message = {
                    type: 'I',
                    content: '<?xml version="1.0" encoding="UTF-8" ?><root>  <series shelf="total">-1627455397</series>  <rising>    <fun browserling="happy">-1013154478</fun>    <zero>648985757</zero>    <best forty="jack">      <sets>        <sheet>fill</sheet>        <plates tune="atomic">216140986</plates>        <couple>using</couple>        <affect>-191534042</affect>        <sun>1317737399.0601077</sun>        <appearance>grade</appearance>        <southern>touch</southern>        <through>push</through>        <establish road="soon">-985413603.3636069</establish>        <citizen>1263989194</citizen>        <pool>          <article>-1693566087</article>          <follow beat="usually">838100744.8883867</follow>          <twenty fort="refused">            <home>symbol</home>            <plates>              <raw>troops</raw>              <phrase diagram="shown">1542873241.7233415</phrase>              <split begun="live">unless</split>              <hand car="produce">necessary</hand>              <high>380705637</high>              <kill>more</kill>              <her>1641226290</her>              <flame>this</flame>              <protection>flight</protection>              <vapor event="forth">-1690513254.9852686</vapor>              <trouble spell="path">remain</trouble>              <action band="headed">782219462</action>            </plates>            <whole>twelve</whole>            <usually>-705741521.1767588</usually>            <remain>1324544667.4793897</remain>            <milk>properly</milk>            <explain>-1366231753</explain>            <value>refer</value>            <everything poetry="travel">1099014778.1120133</everything>            <for>football</for>            <guess blood="fun">solution</guess>            <quick poor="terrible">-1512187975.9010048</quick>          </twenty>          <you>win</you>          <citizen>at</citizen>          <nation connected="laid">860208852.6458688</nation>          <giving>salt</giving>          <two>1567989746.8361716</two>          <lead roof="ride">kids</lead>          <necessary>contrast</necessary>          <chart>energy</chart>          <duty discover="star">after</duty>        </pool>        <hit>ancient</hit>      </sets>      <human shine="tiny">colony</human>      <atomic compass="bill">1193896020.6789298</atomic>      <meat>1830807534.229972</meat>      <closely>1613361118</closely>      <shake riding="till">545490356</shake>      <pack>short</pack>      <replace girl="telephone">road</replace>      <bright out="mass">best</bright>      <like discover="steady">412117604</like>      <community>butter</community>      <instead>comfortable</instead>    </best>    <bell sign="kill">interior</bell>    <desert pilot="tobacco">court</desert>    <package largest="board">dog</package>    <quiet>1831735789</quiet>    <angry ancient="adjective">claws</angry>    <suppose origin="signal">-278751696.2178688</suppose>    <terrible>parts</terrible>    <inside held="crack">-1091693472</inside>    <luck raise="fur">1088388180.783997</luck>  </rising>  <fill>plain</fill>  <told energy="graph">1807532843.550847</told>  <join pan="metal">machine</join>  <wherever pain="pleasant">-1147984095</wherever>  <stranger wagon="everybody">wash</stranger>  <accept>act</accept>  <on primitive="mad">kind</on>  <act to="circle">vegetable</act>  <oxygen>must</oxygen>  <pleasure>1411104369</pleasure></root>',
                    code: Math.random().toString(36).slice(2),
                    systemType: 'S',
                    site: 'T'
                };

                var messageCalc = {
	                "location": "MTJT",
	                "codeMessageDefinition": "CALC_SOAP"
                }

                this.$store.dispatch("api/post", {
                    url: process.env.VUE_APP_ADM_API_URL + "adm-service/adm/integrationMessageConfig/sendMensageCalculator", 
                    data: messageCalc
                }, {root: true})
                .then(data => {
                });
            },
            reciveMessage(){
                var message = {
                    type: 'I',
                    content: ''
                };

                this.$store.dispatch("api/post", {
                    url: process.env.VUE_APP_ADM_API_URL + "adm-service/adm/integrationMessage/reciveMensage/", 
                    data: message
                }, {root: true})
                .then(data => {
                    console.log(data);
                });
            },

            reciveMessageSOAP(){
                this.$store.dispatch("api/testWSEndPoint", {

                }, {root: true})
                .then(data => {
                });
            }

        }
    };
</script>
